export default "__VITE_ASSET__34bc7af3__"